'use client'

import type { RegisterModalProps } from '@maestro/commerce-blocks/components/register/register.types'

import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import { useEffect } from 'react'

import { useRegisterModal } from '@maestro/commerce-blocks/components/register/batons/use-register-modal'
import { SlideInBody } from '@pearlconvert/ui/components/slide-in'
import { useModals } from '@pearlconvert/ui/providers/modals/modals.context'

const RegisterForm = dynamic(
  () => import('@maestro/commerce-blocks/components/register/register-form')
)

export default function RegisterModal(props: RegisterModalProps) {
  const { cmsPlaceholders, consents } = props
  const t = useTranslations('commerce-blocks')
  const { addModal } = useModals()
  const { registerModalKey } = useRegisterModal()

  useEffect(() => {
    addModal({
      key: registerModalKey,
      hash: registerModalKey,
      Component: (
        <SlideInBody>
          <RegisterForm cmsPlaceholders={cmsPlaceholders} consents={consents} />
        </SlideInBody>
      ),
      props: {
        title: t('auth.register.title'),
        customClassName: 'register-modal',
      },
    })
  }, [addModal, cmsPlaceholders, consents, t, registerModalKey])

  return null
}
